import { withKeycloak } from "@react-keycloak/web";
import { Badge } from "antd";
import React from "react";
import { labels } from "../../../localization/labels";
import { selectFilter } from "../../../services/FilteringUtils";
import PartyMessageService from "../../../services/PartyMessageService";
import PartySession from "../../../session/PartySession";
import { constants } from "../../../utils/Constants";
import PathUtil from "../../../utils/PathUtil";
import TableUtils from "../../core/Table/TableUtils";
import { paths } from "../../paths";
import TableComponent from "../page/TableComponent";
import PartyMessages from "./PartyMessages";

class PartyMessagesContainer extends TableComponent {
  constructor(props) {
    super(props);

    this.partyMessageService = new PartyMessageService(this.keycloak);

    this.ignoreFilters();

    this.state = {
      ...this.initialState(),
      contextMenuItems: [
        {
          label: labels.newTab,
          callback: this.openInNewTab,
          menuItemType: constants.MENU_ITEM_TYPE_NEW_TAB,
          ignoreActive: true
        },
        {
          label: labels.markAsRead,
          callback: this.handleOnChangeReadStatus,
          menuItemType: constants.MENU_ITEM_TYPE_MARK_AS_READ
        },
        {
          label: labels.markAsUnread,
          callback: this.handleOnChangeReadStatus,
          menuItemType: constants.MENU_ITEM_TYPE_MARK_AS_UNREAD
        }
      ]
    };
  }

  getComponentTitle = () => {
    return labels.partyMessagesTitle;
  };

  initialSortInfo() {
    return [
      {
        orderBy: "read",
        direction: "asc"
      },
      {
        orderBy: "dispatchDate",
        direction: "desc"
      }
    ];
  }

  reload = () => {
    this.loadData(this.state.pageInfo);
  };

  loadData = pageInfo => {
    this.prepareCall(
      this.partyMessageService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  columns = this.initColumns();

  initialFilters() {
    return this.mustFilters();
  }

  mustFilters() {
    return {
      partyId: selectFilter(PartySession.getPartyId())
    };
  }

  initColumns() {
    return super.initColumns([
      {
        dataField: "read",
        sort: false,
        classes: "column-id",
        headerClasses: "column-header-read",
        formatter: this.readFormater
      },
      {
        dataField: "name",
        text: labels.title,
        sort: false,
        formatter: TableUtils.textFormatter,
        headerClasses: "column-header",
        headerFormatter: this.formatHeader
      },
      {
        dataField: "dispatchDate",
        text: labels.dispatchDate,
        formatter: TableUtils.dateFormatter,
        sort: false,
        headerClasses: "column-header",
        headerFormatter: this.formatHeader
      }
    ]);
  }

  readFormater(cell, row) {
    const badge = !cell ? <Badge status={"processing"} /> : null;
    return badge;
  }

  onRowClick = (_, row) => {
    this.changePath(this.createMessagePath(row), row.name);
  };

  openInNewTab = row => {
    window.open(this.createMessagePath(row), "_blank", "noopener");
  };

  createMessagePath = row => {
    return PathUtil.itemPath(`${paths.PARTY_MESSAGES}${paths.DETAIL}`, row.id);
  };

  handleOnChangeReadStatus = row => {
    const newRow = { ...row, read: !row.read };
    this.prepareCall(
      this.partyMessageService.patchEntity(
        newRow,
        row,
        this.onReadStatusChanged,
        this.messageHandler.handleError,
        undefined
      )
    );
    this.performCalls();
  };

  onReadStatusChanged = () => {
    this.startLoading(this.state.pageInfo, this.sortInfo);
  };

  render() {
    return (
      <PartyMessages
        {...this.renderProps()}
        onRowClick={this.onRowClick}
        contextMenuItems={this.state.contextMenuItems}
      />
    );
  }
}

export default withKeycloak(PartyMessagesContainer);
